import { Stack } from '@mui/material';
import { DataGrid, GridColDef, GridCellParams } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import Dot from '../Utils/Dot';
import { Typography } from '@ts/storybook';

const getCurrentDate = () => {
  const currentDate = dayjs().format('DD/MM/YYYY HH:MM');
  return currentDate;
};

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'name', headerName: 'Name', width: 130 },
  { field: 'type', headerName: 'Type', width: 130 },
  {
    field: 'progress',
    headerName: 'Progress',
    width: 200,
    renderCell: params => {
      const value = Number(params.value);
      const progress = value >= 0 ? Math.min(100, value) : 0;
      const color = value >= 0 ? '#00c853' : '#f44336';

      return (
        <div
          className="w-full h-6 rounded-xs"
          style={{
            backgroundColor: '#f5f5f5',
            border: '1px solid #ccc',
          }}
        >
          <div
            className="h-full rounded-xs"
            style={{
              width: `${progress}%`,
              backgroundColor: color,
            }}
          />
          <div
            className="relative top-[-22px] left-[72px] bg-[#0000008c] w-fit text-white rounded-md"
            style={{
              paddingInline: '5px',
            }}
          >{`${progress}%`}</div>
        </div>
      );
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 200,
    renderCell: params => {
      let color: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
      let title;

      switch (Number(params.value)) {
        case 0:
          color = 'warning';
          title = 'Pending';
          break;
        case 1:
          color = 'success';
          title = 'Approved';
          break;
        case 2:
          color = 'error';
          title = 'Rejected';
          break;
        default:
          color = 'primary';
          title = 'None';
      }

      return (
        <Stack direction="row" spacing={1} alignItems="center">
          <Dot color={color} />
          <Typography text={title} />
        </Stack>
      );
    },
  },
  { field: 'time', headerName: 'Date', width: 150, valueGetter: getCurrentDate },
];

const rows = [
  { id: 1, name: 'Event 1', date: new Date().getDate(), type: 'Truck load', progress: 75, status: 0 },
  { id: 2, name: 'Event 2', date: new Date(), type: 'Truck load', progress: 50, status: 1 },
  { id: 3, name: 'Event 3', date: new Date(), type: 'RTI maintenance', progress: 90, status: 2 },
  { id: 4, name: 'Event 4', date: new Date(), type: 'Training', progress: -10, status: 0 },
];

const EventsTable = () => {
  return <DataGrid rows={rows} columns={columns} checkboxSelection={false} style={{ borderWidth: '0px', height: 605 }} />;
};

export default EventsTable;
